<template>
  <div>
    <div class="container">
      <div class="form-user">
        <h1 class="title is-3">CHANGE PASSWORD</h1>
        <form @submit.prevent="validateBeforeSubmit">
          <b-field
            label="New Password"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')"
          >
            <b-input
              v-model="password"
              placeholder="Password"
              type="password"
              name="password"
              v-validate="{required: true, regex: /\w/, min: 8}"
              size="is-medium"
            ></b-input>
          </b-field>

          <b-field
            label="Confirm Password"
            :type="{'is-danger': errors.has('confirm-password')}"
            :message="[{
              'The confirm password field is required' : errors.firstByRule('confirm-password', 'required'),
              'The confirm password is not valid' : errors.firstByRule('confirm-password', 'is')
            }]"
          >
            <b-input
              v-model="confirmPassword"
              placeholder="Confirm Password"
              v-validate="{ required: true, is: password }"
              type="password"
              name="confirm-password"
              size="is-medium"
            ></b-input>
          </b-field>

          <div class="field is-grouped is-grouped-centered">
            <div class="control">
              <button type="submit" class="button is-info">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import jwt from "jsonwebtoken";
  import UsersService from "@/services/UsersService";

  export default {
    name: "Update",
    data() {
      return {
        password: "",
        confirmPassword: ""
      };
    },
    methods: {
      updateUser() {
        const token = localStorage.getItem("usertoken");
        const decode = jwt.decode(token);
        const user = {
          username: decode.username,
          lastName: decode.lastName,
          firstName: decode.firstName,
          entityTag: decode.entityTag,
          password: this.password
        };
        UsersService.updateUser({ user, token })
          .then(res => {
            if (res.data.status) {
              this.resetData();
              this.$nextTick(() => {
                this.$validator.reset();
              });
              this.$toast.open({
                message: res.data.message || "Đổi mật khẩu thành công",
                type: "is-info"
              });
            } else {
              this.$toast.open({
                message:
                  res.data.message || "Lỗi máy chủ. Vui lòng thử lại",
                type: "is-danger"
              });
            }
          })
          .catch(() => {
            this.$toast.open({
              message: "Lỗi máy chủ. Vui lòng thử lại",
              type: "is-info"
            });
          });
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.updateUser();
            return;
          }
          this.$toast.open({
            message: "Mẫu đơn không hợp lệ! Vui lòng kiểm tra các trường nhập.",
            type: "is-danger"
          });
        });
      },
      resetData() {
        this.password = "";
        this.confirmPassword = "";
      }
    }
  };
</script>
